import { WorkerAttr } from '@/types/worker-attr';

export function getLiquidTemplate(
  tag: WorkerAttr['tag'],
  id: string,
  fallback: string | undefined,
  dataType: WorkerAttr['dataType'],
) {
  fallback ??= '';

  let pipes = `| default: "${fallback}"`;

  if (dataType === 'date') {
    pipes += ` | date: "MMMM D, YYYY"`;
  }

  return `{{ ${tag}.${id} ${pipes} }}`;
}

